import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Slider from 'react-slick'
import CustomPaging from './components/CustomPaging'
import { ArrowsExpandIcon } from '@heroicons/react/outline'
import ImagePreviewModal from './components/ImagePreviewModal'

/**
 * Return new Carousel with Images with settings passed by props
 * @param {Object} settings Settings for the Slider component.
 * @param {Array} images Array of images to be displayed in the Carousel.
 */
const CarouselImages = ({
    images = [],
    settings,
    activeIndex = 0,
    heightImage = 400,
}) => {
    const [activeSlide, setActiveSlide] = useState(activeIndex)
    const [previewOpen, setPreviewOpen] = useState(false)

    const renderPaging = i => (
        <CustomPaging
            i={i}
            onChange={() => setActiveSlide(i)}
            activeSlide={activeSlide}
        />
    )

    const renderViewPreviewButton = () => {
        return (
            <button className="w-auto h-auto p-2 flex items-center justify-center bg-white border-grayLines z-150 absolute bottom-4 left-4">
                <ArrowsExpandIcon
                    onClick={() => setPreviewOpen(true)}
                    className="stroke-2 stroke-current mr-0 m-0 text-textDarkerGray w-6 h-6"
                />
                <ImagePreviewModal
                    url={images[activeSlide]}
                    setIsOpen={setPreviewOpen}
                    isOpen={previewOpen}
                />
            </button>
        )
    }

    const defaultSettings = {
        lazyLoad: true,
        dots: false,
        infinite: true,
        speed: 500,
        width: '100%',
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        centerMode: true,
        customPaging: renderPaging,
        afterChange: val => {
            setActiveSlide(val)
        },
    }

    return (
        <div className="h-auto max-h-full w-full rounded-2xl">
            <Slider
                dotsClass="bg-red"
                className="p-0 m-auto"
                initialSlide={activeIndex}
                {...(settings || defaultSettings)}
            >
                {images.map((image, index) => {
                    return (
                        <div
                            className="w-full h-auto relative"
                            style={{ width: '100%', height: '100%' }}
                            key={index}
                        >
                            {renderViewPreviewButton()}
                            <img
                                style={{ height: heightImage }}
                                className="rounded-2xl object-cover w-full"
                                src={image}
                            />
                        </div>
                    )
                })}
            </Slider>
        </div>
    )
}

CarouselImages.propTypes = {
    images: PropTypes.arrayOf(PropTypes.string).isRequired,
    settings: PropTypes.object,
    activeIndex: PropTypes.number,
    heightImage: PropTypes.oneOfType([PropTypes.number, PropTypes.any]),
}

export default CarouselImages
